import { Component, HostListener, Input, OnInit } from "@angular/core";
import { ColorCode } from "../../Company.enum";
import { DisplayType, Roles } from 'src/app/utils';
import { EmployeeService } from 'src/app/services/employee.service';
import { ActivatedRoute } from "@angular/router";
import { ConfirmationDailogService } from "../../shared/confirm-dailog/confirmation-dailog.service";
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-active-employees',
  templateUrl: './active-employees.component.html',
  styleUrls: ['./active-employees.component.scss']
})
export class ActiveEmployeesComponent implements OnInit {

  openOptionDrawer: boolean;
  // @Input() list;
  list;
  employeeCount: number = 0;
  displayType = DisplayType;
  parkId = (localStorage.getItem('parkId')) ? localStorage.getItem('parkId') : null;
  parTenantId: any;
  //building
  parkBuilding: any[] = []
  selectedBuidling: any[] = []
  //employee type
  selectedEmpType: any[] = []
  //right types
  selectedRights: any[] = []

  checkboxValue: boolean = false;
  isChecked = false
  selectedUsers: any[] = []
  selectedUsersForFilter: any[] = []
  selectedUsersForVerify: any[] = []

  verified: boolean = true
  nonverified: boolean = true
  withRights: boolean = true
  withOutrights: boolean = true
  pendingApproval: boolean = true
  deactive: boolean = true
  block: boolean = true
  page = 1;
  pageSize = 50;
  totalCount = 0
  noPages = 1;
  isLoadData = false
  companyAdd: any;

  constructor(private employeeService: EmployeeService,
    private activateRoute: ActivatedRoute,
    private confirmService: ConfirmationDailogService,
    private rolebasedactionService: RolebasedactionService,
  ) {
    this.parTenantId = this.activateRoute.snapshot.params.id;
    console.log("came here");
    this.getBuildingsByParkId();

  }

  ngOnInit() {
    this.companyAdd = this.rolebasedactionService.checkUserRolePermissionExits('Company:Create');
    // this.filterActiveEmployee(this.list)
    this.initailFunctions();
  }

  initailFunctions() {
    this.setEmpType({ name: 'All', image: '', checked: false });
    // this.setBuildingName({parkBuildingName: 'All', parkBuildingId: 'All', checked: false});
    this.setInviteRights({ name: 'All', checked: false });
  }

  filterActiveEmployee(employees: any[]) {
    employees.filter(res => {
      if (res.isActive && res.employeeRole !== Roles.ParkAdmin) {
        this.employeeCount++;
      }
    });
  }
  buildingProperty: any = ['All', ' Creator', ' Discoverer', ' Innovator'];
  empTypes: any = [{ name: 'All', image: '', checked: false, id: 1 }, { name: 'Verified', image: 'assets/images/company/verified_user.png', checked: false, id: 2 }, { name: 'Non-verified', image: 'assets/images/company/verified_user_pending.png', checked: false, id: 3 }];
  inviteRights: any = [{ name: 'All', checked: false, id: 1 }, { name: 'With Rights', checked: false, id: 2 }, { name: 'Without Rights', checked: false, id: 3 }, { name: 'Pending Approval', checked: false, id: 5 }];
  buildingName: boolean;
  empType: boolean;
  employeeType: string;
  invRights: boolean;
  vmsInvite: string;
  buildingTitle: any = [];
  searchText = ''
  parkAdmin = 7
  dropdownFlag: boolean = true;
  dropdownFlag2: boolean = true;
  // openOptionDrawer: boolean;
  dotDropDownDetail: any

  @HostListener('click', ['$event'])
  captureClick(event) {
    this.dotDropDownDetail = undefined
    if (event.target.className !== 'drawer-container') {
      this.openOptionDrawer = false;
    }
  }

  closeAllTabs() {
    this.openOptionDrawer = false;
    this.dotDropDownDetail = undefined
  }




  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  enterName(field) {
    if (field == 'buildingName') {
      this.buildingName = !this.buildingName;
    }
    if (field == 'invRights') {
      this.invRights = !this.invRights;
    }
    if (field == 'empType') {
      this.empType = !this.empType;
    }
  }

  setBuildingName(item, event = '') {
    let AllChecked;
    if (this.parkBuilding[0].checked == true) {
      console.log("isnide thiskk ");
      this.selectedBuidling = [];
      this.buildingTitle = []
      this.parkBuilding = this.parkBuilding.map(res => {
        res.checked = false;
        return res;
      })
    }
    this.buildingTitle.push(item)
    console.log(this.buildingTitle)
    if (item.parkBuildingId == 'All') {
      this.selectedBuidling = []
      AllChecked = !item.checked
      this.buildingTitle = (AllChecked) ? this.removeAll() : [];
    }
    this.parkBuilding = this.parkBuilding.map(res => {
      if (item.parkBuildingId == 'All') {
        res.checked = AllChecked;
      } else if (item.parkBuildingId == res.parkBuildingId) {
        res.checked = !res.checked;
      }
      return res;
    })
    this.getCheckedData(event);
    console.log(this.selectedBuidling);
  }

  /// new api to be provided
  markAsAdmin($event = undefined) {
    console.log($event);
    let payload = {}
    if ($event !== undefined) {
      payload = {
        useridList: [$event.id],
        roleId: this.parkAdmin
      }
    } else {
      payload = {
        useridList: this.selectedUsers,
        roleId: this.parkAdmin
      }
    }
    this.employeeService.markAsAdmin(payload).subscribe(res => {
      console.log(res);
      if (res.isValid) {
        this.selectedUsers = []
        this.getEmployeeByFilter();
      }
    });
  }

  removeAsAdmin($event = undefined) {
    console.log($event);
    let payload = {}

    this.confirmService.confirm('Please confirm..', 'Do you really want to Remove Admin ?', 'Remove')
      .then((confirmed) => {
        console.log('User confirmed:', confirmed)
        if ($event !== undefined) {
          payload = {
            useridList: [$event.id],
            roleId: this.parkAdmin
          }
        } else {
          payload = {
            useridList: this.selectedUsers,
            roleId: this.parkAdmin
          }
        }

        this.employeeService.revokeAsAdmin(payload).subscribe(res => {
          console.log(res);
          if (res.isValid) {
            this.selectedUsers = []
            this.getEmployeeByFilter();
          }
        });
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  handlePageChange(event) {
    this.page = event;
    this.getEmployeeByFilter()
  }

  checkSelectedUserIfAdmin() {
    let check = false, check2 = false;
    this.selectedUsers.forEach((res, i) => {
      console.log(res);
      this.list.forEach(element => {
        if (element.userId == res && element.employeeRole === Roles.ParkAdmin) {
          this.dropdownFlag = false;
          check = true;
        }
        if (element.userId == res && element.employeeRole !== Roles.ParkAdmin) {
          this.dropdownFlag2 = false;
          check2 = true;
        }
      });
      if (i == (this.selectedUsers.length - 1) && !check) {
        this.dropdownFlag = true;
      }
      if (i == (this.selectedUsers.length - 1) && !check2) {
        this.dropdownFlag2 = true;
      }
    });
  }

  getCheckedData(event = '') {
    this.selectedBuidling = []
    let resultArr = this.parkBuilding.slice(1);
    let filteredArr = resultArr.filter(res => {
      if (res.checked) {
        return res
      }
    })
    this.selectedBuidling = filteredArr.map(res => {
      return res.parkBuildingName
    });
    this.parkBuilding[0].checked = ((this.parkBuilding.length - 1) === this.selectedBuidling.length) ? true : false
    console.log(this.selectedBuidling);
    if (event == 'click') {
      this.getEmployeeByFilter()
    }
  }

  removeAll($filter = '') {
    if ($filter == 'name') {
      let resultArr = this.parkBuilding.slice(1);
      return resultArr.map(res => {
        return res.parkBuildingName
      });
    } else {
      return this.parkBuilding.slice(1);
    }
  }

  setEmpType(item, event = '') {
    console.log(item);
    if (this.empTypes[0].checked) {
      this.empTypes = this.empTypes.map(res => {
        res.checked = false
        return res
      });
    }
    let AllChecked
    // this.employeeType=item
    if (item.name == 'All') {
      AllChecked = !item.checked
    }
    this.empTypes = this.empTypes.map(res => {
      if (item.name === 'All') {
        res.checked = AllChecked;
        return res
      } else if (res.name === item.name) {
        res.checked = !res.checked
        return res;
      }
      return res
    });
    console.log(this.empTypes)
    this.getCheckedEmpTypes(event);
  }

  getCheckedEmpTypes(event = '') {
    this.selectedEmpType = []
    let resultArr = this.empTypes.slice(1);
    let filteredArr = resultArr.filter(res => {
      if (res.checked) {
        return res
      }
    })
    this.selectedEmpType = filteredArr.map(res => {
      return res.name
    });
    this.empTypes[0].checked = ((resultArr.length) === this.selectedEmpType.length) ? true : false
    console.log(this.selectedEmpType);
    if (event == 'click') {
      this.getEmployeeByFilter()
    }
  }

  setInviteRights(item, event = '') {
    this.vmsInvite = item

    if (this.inviteRights[0].checked == true) {
      this.inviteRights = this.inviteRights.map(res => {
        res.checked = false
        return res
      });
    }

    console.log(item);
    let AllChecked
    // this.employeeType=item
    if (item.name == 'All') {
      AllChecked = !item.checked
    }
    this.inviteRights = this.inviteRights.map(res => {
      if (item.name === 'All') {
        res.checked = AllChecked;
        return res
      } else if (res.name === item.name) {
        res.checked = !res.checked
        return res;
      }
      return res
    });
    this.getCheckedInvTypes(event);
  }

  getCheckedInvTypes(event = '') {
    this.selectedRights = []
    let resultArr = this.inviteRights.slice(1);
    let filteredArr = resultArr.filter(res => {
      if (res.checked) {
        return res
      }
    })
    this.selectedRights = filteredArr.map(res => {
      return res.name
    });
    this.inviteRights[0].checked = ((resultArr.length) === this.selectedRights.length) ? true : false
    console.log(this.selectedRights);
    if (event == 'click') {
      this.getEmployeeByFilter()
    }

  }

  getBuildingsByParkId() {
    this.employeeService.getBuildingByParkIdAndTenatID(this.parkId, this.parTenantId).subscribe(res => {
      this.parkBuilding = res.list.map(res => {
        res.checked = false
        return res
      });
      this.parkBuilding.unshift({ parkBuildingName: 'All', parkBuildingId: 'All', checked: false });
      this.setBuildingName({ parkBuildingName: 'All', parkBuildingId: 'All', checked: false });
      this.getEmployeeByFilter();
    });
  }

  getEmployeeByFilter() {
    this.closeAllTabs();
    // this.captureClick('abc')
    // let payload =  {
    //   "parkTenantId": "3fa85f64-5717-4562-b3fc-2c963f66afa6", //3297F0F2-35D3-4231-919D-1CFCF4035975
    //   "buildingName": [
    //     ""
    //   ],
    //   "verified": "",
    //   "nonverified": "",
    //   "withRights": "",
    //   "withOutrights": "",
    //   "pendingApproval": "",
    //   "deactive": "",
    //   "block": ""
    // }
    let payload = {
      "parkTenantId": this.parTenantId,//"B8657E8D-C137-46A4-9DE0-BDBB01B8FC04",
      "buildingName": this.selectedBuidling,
      "verified": (this.empTypes[1].checked) ? true : false,
      "nonverified": (this.empTypes[2].checked) ? true : false,
      "withRights": (this.inviteRights[1].checked) ? true : false,
      "withOutrights": (this.inviteRights[2].checked) ? true : false,
      "pendingApproval": (this.inviteRights[3].checked) ? true : false,
      // "deactive": this.deactive,
      // "block": this.block,
      "pageNo": this.page,
      "size": this.pageSize,
      "deactive": false,
      "searchTerm": this.searchText,
      "parkId": this.parkId,
      "actionUserCategory": "ActiveDeactive"
    }
    this.employeeService.getEmployeeListByFilter(payload).subscribe(res => {
      if (res.isValid) {
        console.log(res.data.employees);
        this.totalCount = res.data.count;
        this.noPages = Math.ceil(this.totalCount / this.pageSize);
        this.filterActiveEmployee(res.data.employees);
        this.list = res.data.employees
        this.isLoadData = true
      } else {
        this.isLoadData = true
      }

    });
  }


  selectDeselectUsers() {
    this.isChecked = !this.isChecked
    this.checkboxValue = this.isChecked
    this.selectedUsers = [];
    if (this.isChecked) {
      this.list.filter(res => {
        console.log(res);
        if (res.isVerified === true && res.isRegistered === true) {
          this.selectedUsers.push(res.userId);
          this.selectedUsersForFilter.push({ parkUserId: res.userId }); //Change to parkUserId
          this.selectedUsersForVerify.push({ parkUserId: res.userId });
        }
      });
    }
    console.log(this.selectedUsers);
    this.checkSelectedUserIfAdmin();
  }

  getSelectedUser(event) {
    console.log(event);
    console.log(this.employeeCount);
    if (event.checked) {
      this.selectedUsers.push(event.id);
    } else {
      var index = this.selectedUsers.indexOf(event.id);
      this.selectedUsers.splice(index, 1);
    }
    this.isChecked = (this.employeeCount == this.selectedUsers.length) ? true : false
    console.log(this.selectedUsers);
    this.checkSelectedUserIfAdmin();
  }

  giveEmployeeVmsInvitationRights() {
    let payload = {
      useridList: this.selectedUsers,
      isVMSAccess: true
    }
    this.employeeService.giveEmployeeVMSInvitationRights(payload).subscribe(res => {
      console.log(res);
      this.getEmployeeByFilter();

    });
  }

  changeEmpStatus(event) {
    let payload = [event.item.userId]
    if (event.type == 'revoke') {
      let body = {
        useridList: payload,
        isVMSAccess: false
      }
      this.employeeService.giveEmployeeVMSInvitationRights(body).subscribe(res => {
        if (res.isValid) {
          this.getEmployeeByFilter();
        }
      });
    } else {
      this.employeeService.approveVmsRights(payload).subscribe(res => {
        console.log(res);
        this.getEmployeeByFilter();
      })
    }
  }

  changeEmployeeStatus(type) {
    let sample = [{
      "isActive": true,
      "createdBy": 0,
      "createdDate": "2021-09-27T15:44:15.664Z",
      "modifiedBy": 0,
      "modifiedDate": "2021-09-27T15:44:15.664Z",
      "parkUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      "isBlocked": true,
      "isApproved": true,
      "isVerified": true,
      "employeeStatus": 1
    }]
    let payload = []

    if (type == 'deactivate') {
      payload = this.selectedUsersForFilter.map(res => {
        res.isVerified = true
      });
    } else {
      payload = this.selectedUsersForFilter.map(res => {
        res.isBlocked = true
      });
    }
    this.employeeService.saveEmployeeStatus(payload).subscribe(res => {
      console.log(res);
      this.getEmployeeByFilter();
    });
  }

  verifyEmployees() {
    let payload = this.selectedUsersForVerify.map(res => {
      res.isVerified = true
    });
  }
}

